import React, { useEffect, useRef, useState } from 'react'
import { useForm, FormProvider } from 'react-hook-form'
import PropTypes from 'prop-types'
import { yupResolver } from '@hookform/resolvers/yup'

import AddIcon from '@mui/icons-material/Add'

import { activitySchema } from '../../schemas/activitySchema'
import { BoldFormTitle } from '../styles/Text'
import { FlexEndContainer, PaddedForm, StyledDialog, StyledDialogContent } from '../styles/Containers'
import { ErrorMessage } from '../common/UserMessage'
import Button, { IconButton, SecondaryButton } from '../common/Button'
import axios from '../../dataClient/dataClient'
import ActivityForm from './ActivityForm'
import { constructDateFromDateAndTime } from '../../util/formatting'

function NewActivityButton({ foiId, onSuccess = () => {}, disabled = false }) {
  const [isVisible, setIsVisible] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState(false)

  const methods = useForm({ resolver: yupResolver(activitySchema) })
  const { handleSubmit, reset } = methods

  const handleOpen = () => setIsVisible(true)
  const handleClose = () => {
    setIsVisible(false)
    reset()
    setError(false)
    setIsLoading(false)
  }

  const onError = (errors, e) => console.error('Error', errors, e)

  async function onSubmit(data) {
    setIsLoading(true)
    setError(false)

    const activityDate = constructDateFromDateAndTime(data.date, data.time)

    axios
      .post('/activity', { foiId, date: activityDate, name: data.label, type: 'MANUAL' })
      .then(({ data }) => {
        handleClose()
        onSuccess({ ...data.data, date: new Date(data.data.date) })
      })
      .catch(e => {
        console.error('Failed creating activity', e)
        setError(true)
        setIsLoading(false)
      })
  }

  const isMounted = useRef(true)

  useEffect(() => {
    return () => {
      isMounted.current = false
    }
  }, [])

  return (
    <>
      <IconButton aria-label="Create Activity" disabled={disabled} onClick={handleOpen}>
        <AddIcon />
      </IconButton>
      <StyledDialog fullWidth open={isVisible} onClose={handleClose} keepMounted={false}>
        <StyledDialogContent>
          <FormProvider {...methods}>
            <PaddedForm onSubmit={handleSubmit(onSubmit, onError)}>
              <BoldFormTitle>Create Activity</BoldFormTitle>
              <ActivityForm />
              {error && <ErrorMessage />}
              <FlexEndContainer>
                <SecondaryButton onClick={handleClose} disabled={isLoading}>
                  Cancel
                </SecondaryButton>
                <Button type="submit" loading={isLoading}>
                  Create
                </Button>
              </FlexEndContainer>
            </PaddedForm>
          </FormProvider>
        </StyledDialogContent>
      </StyledDialog>
    </>
  )
}

NewActivityButton.propTypes = {
  foiId: PropTypes.string.isRequired,
  onSuccess: PropTypes.func,
  disabled: PropTypes.bool
}

export default NewActivityButton
